// エンドポイント:
// GET /api/v1/tenants/{tenantId}/shipments/{shipmentId}/visits/{visitId}/delivery-work/attachments/{attachmentId}
export const downloadTenantShipmentAttachmentEndpoint = (
  tenantId: number,
  shipmentId: number,
  visitId: number,
  attachmentId: number
): string =>
  `/tenants/${tenantId}/shipments/${shipmentId}/visits/${visitId}/delivery-work/attachments/${attachmentId}`
